import { ILoaderMoviesProps } from 'src/lib/types/filminfo/ILoaderMoviesProps';
import KommerPoster from 'src/components/kommendefilmer/KommerPoster';
import KommerTextRow from 'src/components/kommendefilmer/KommerTextRow';
import SPosterContainer from 'src/components/kommendefilmer/PosterContainer';
import SSectionTitle from 'src/components/kommendefilmer/SectionTitle';
import STextListContainer from 'src/components/kommendefilmer/TextListContainer';
import { isPremiereThisWeek } from 'src/components/kommendefilmer/helperFunctions';
import theme from 'src/components/themes/DefaultTheme';
import styled, { css } from 'src/lib/styles/css';

//#region [Props]
type PremieresThisWeekProps = {
	showTextList?: boolean;
} & ILoaderMoviesProps;
//#endregion

//#region [Component]
export default function PremieresThisWeek({ movies, showTextList = false }: PremieresThisWeekProps) {

	const _movies = movies?.filter(m => !!m.sanityImagePosterUrl && isPremiereThisWeek(m));

	if ((_movies?.length ?? 0) === 0) {
		return null;
	}

	if (showTextList) {
		return <STextListContainer>
			<SPageSectionTitle>Premierer denne uken</SPageSectionTitle>
			{_movies?.map(movie => <KommerTextRow key={movie.mainVersionId} film={movie} dateFormat='thisweek'/>)}
		</STextListContainer>
	}

	return <SPosterContainer>
		<SPageSectionTitle>Premierer denne uken</SPageSectionTitle>
		{_movies?.map(movie => <KommerPoster key={movie.mainVersionId} film={movie} dateFormat='thisweek' width={235}/>)}

	</SPosterContainer>;
}
//#endregion

const SPageSectionTitle = styled(SSectionTitle)`
	@media (min-width: 550px) {
		margin-bottom: 0;
	}
`;
